/****************************************************
 * Module Name:  changeReceiveLocationProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class ChangeReceiveLocationProxy {
  static GetAllChangeLocation = (userId, callback) => {
    let params = {
      userid: userId,
    };
    restAPICall(
      Constants.MANAGER_URL + "/stone/location",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllReceiveLocation = (userId, callback) => {
    let params = {
      userid: userId,
    };
    restAPICall(
      Constants.MANAGER_URL + "/stone/location/receive",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateChangeLocation = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/location",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
  static UpdateReceiveLocation = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/stone/location/receive",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
